
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M28.019 7.42c-2.5-.576-5.288.577-7.019 2.885-1.73-2.308-4.519-3.461-7.019-2.884-2.788.673-4.615 3.076-4.711 6.25-.192 8.749 11.442 15.96 11.634 16.056h.192c.096 0 11.73-7.211 11.634-16.057 0-3.173-1.923-5.673-4.711-6.25"}}),_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#234652","stroke-miterlimit":"10","d":"M13.52 32.246a11.1 11.1 0 0 1-2.789-2.019c-1.923-1.73-3.46-3.558-3.365-5.288.096-1.923 1.827-1.827 1.827-1.827h.096m25.191 9.134a11.1 11.1 0 0 0 2.789-2.019c1.923-1.73 3.46-3.558 3.365-5.288-.096-1.923-1.827-1.827-1.827-1.827h-.096M4.289 17.824v7.019c0 3.846-.192 5.576 3.366 9.134 2.596 2.596 5.096 4.23 5.096 4.23v4.423h8.845v-9.038c0-1.538-.577-4.134-4.807-5.288-.385-.096-.866-.192-1.25-.384-4.327-2.116-4.134-4.616-6.25-4.712v-4.807c0-4.712-5-4.23-5-.577Zm34.422.577v4.807c-2.212.096-2.02 2.692-6.25 4.712-.384.192-.77.288-1.25.384-4.23 1.154-4.807 3.75-4.807 5.288v9.135h8.845v-4.423s2.5-1.635 5.096-4.231c3.558-3.558 3.366-5.288 3.366-9.134V17.92c0-3.75-5-4.23-5 .48ZM31.019 5.42c-2.5-.577-5.288.576-7.019 2.884-1.73-2.308-4.519-3.461-7.019-2.884-2.788.673-4.615 3.076-4.711 6.25-.192 8.749 11.442 15.96 11.634 16.056h.192c.096 0 11.73-7.211 11.634-16.057 0-3.173-1.923-5.673-4.711-6.25Z"}})])
          )
        }
      }
    